import React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { If, Then } from "react-if";

import CustomNotification from "../../../../components/notification";
import ConfirmPopup from "../../../../components/confirmPopup";
import LoadingSpinner from "../../../../components/loadingSpinner";
import OtherTab from "./components/OtherTab";
import CustomButton from "../../../../components/customButton";
import SearchBar from "./searchBar";
import loginService from "../../../../service/login";

import { arrowBottom, rcsIconMain } from "../../../../assets/svg";
import "./styles.scss";
import AddEditNumber from "./components/addEditNumber";
import { Button, Dropdown } from "antd";
import {
  sideNavMail,
  SideNavFilter,
  SidenavDropdown,
} from "../../../../assets/svg";

const SidenavInner = (props) => {
  const {
    sidenavProps,
    sidenavState,
    handleSinglePatientClear,
    handleOnClear,
    tabing,
    handleSearch,
    checkClear,
    loadMoreActiveUsers,
    listingActivePatients,
    loadMoreUnClaimedUsers,
    otherTabRef,
    otherUserClaim,
    addNewButton,
    listingUnclaimedPatients,
    loadMoreOtherUsersNew,
    unclaimedTabRef,
    numbersRef,
    wrapperRef,
    handleCancel,
    handleConfirmPopupCancel,
    handleConfirmPopupDelete,
    handleConfirmPopupClear,
    handleDropdown,
    handleSearchClear,
    showTabsDropdown,
    hideAddPopUp,
    setNewPhoneValue,
    LabelButton,
    handleUnread,
    showPatientReport,
    showPatientLookup,
    notConfigured,
    handleDownloadReport,
  } = props;

  const {
    count,
    patients,
    activePatient,
    unClaimed,
    otherPatients,
    AddPatient,
    otherStaffReload,
    updateOthersPatientListSagaAction,
    popupReducer,
  } = sidenavProps;

  const {
    removeSinglePopup,
    currentItemId,
    otherUserPopup,
    removeListPopup,
    showDropdown,
    search,
    hasMore,
    hasMoreUnclaimed,
    otherStaffList,
    activeTab,
    isLoadingActive,
    showAddNew,
    showAddPopUp,
    phone,
    sideNavEdit,
    selectedTagId,
  } = sidenavState;

  const { customPopupMessage, messageType, message } = popupReducer;

  const { isFetchingActivePatientList } = activePatient;
  const { isFetchingUnclaimedPatientList } = unClaimed;
  const { isFetchingOtherPatientList } = otherPatients;
  const seletedPatientId = patients?.patient?.id || "";
  const isRcsEnableAccountLevel = loginService.getEnableRcs();
  const isRcsEnabledForLiveChat =
    isRcsEnableAccountLevel && sidenavProps?.user?.isRcsForLivechat;

  return (
    <>
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      {removeSinglePopup && (
        <ConfirmPopup
          isDelete
          titleMessage="Confirm to Clear"
          handleCancel={() => handleCancel()}
          handleDelete={() => handleSinglePatientClear(currentItemId)}
          isVisible={removeSinglePopup}
          submitButtonText="Yes"
          cancelButtonText="No"
          message="This conversation will be cleared and archived. To retrieve you need to add this number again."
        />
      )}

      {otherUserPopup.show && (
        <ConfirmPopup
          titleMessage="Confirm to Move"
          handleCancel={() => handleConfirmPopupCancel()}
          handleDelete={() =>
            AddPatient(otherUserPopup.patientData, (data) => {
              if (data) {
                handleConfirmPopupDelete();
              }
            })
          }
          isVisible={otherUserPopup.show}
          submitButtonText="Yes"
          cancelButtonText="No"
          message="Do you want to move the user from others staff to active?"
        />
      )}

      {removeListPopup && (
        <ConfirmPopup
          isDelete
          titleMessage="Confirm to Clear"
          handleCancel={handleConfirmPopupClear}
          handleDelete={handleOnClear}
          isVisible={removeListPopup}
          submitButtonText="Yes"
          cancelButtonText="No"
          message="Are you sure you want to clear this list?"
        />
      )}

      {showAddPopUp && (
        <AddEditNumber
          userDetails={sidenavState.userDetails}
          phone={phone}
          closePopup={hideAddPopUp}
          setValues={setNewPhoneValue}
          activeTab={activeTab}
          sideNavEdit={sideNavEdit}
        />
      )}

      <div className="chat-sidebar-container">
        <div className="chat-sidebar-tabs">
          <div
            className={`sidebar-nav-item ${activeTab === "1" ? "active" : ""}`}
            onClick={() => tabing("1", true)}
          >
            My Active
            {count.active !== undefined &&
              count.active !== 0 && (
                <span className="badge-count">{`(${count.active})`}</span>
              )}
          </div>

          <div
            className={`sidebar-nav-item ${activeTab === "2" ? "active" : ""}`}
            onClick={() => tabing("2", true)}
          >
            Unclaimed
            {count.unclaimed !== undefined &&
              count.unclaimed !== 0 && (
                <span className="badge-count">{`(${count.unclaimed})`}</span>
              )}
          </div>

          <div
            className={`sidebar-nav-item ${activeTab === "4" ? "active" : ""}`}
            onClick={() => tabing("4", true)}
          >
            Other Staff
            {count.other !== undefined &&
              count.other !== 0 && (
                <span className="badge-count">{`(${count.other})`}</span>
              )}
          </div>

          <span
            as="button"
            className="side-nav-items-button"
            onClick={showTabsDropdown}
          >
            {arrowBottom}

            <If condition={showDropdown}>
              <Then>
                <section className="tabs-dropdown" ref={wrapperRef}>
                  <div
                    className={`dropdown-nav-item ${
                      activeTab === "1" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      tabing("1", true);
                      handleDropdown(e);
                    }}
                  >
                    My Active
                  </div>

                  <div
                    className={`dropdown-nav-item ${
                      activeTab === "2" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      tabing("2", true);
                      handleDropdown();
                    }}
                  >
                    Unclaimed
                  </div>

                  <div
                    className={`dropdown-nav-item ${
                      activeTab === "4" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      tabing("4", true);
                      handleDropdown();
                    }}
                  >
                    Other Staff
                  </div>
                </section>
              </Then>
            </If>
          </span>
          {isRcsEnabledForLiveChat && (
            <span className="mobile-rcs-badge">
              {rcsIconMain}
              <span className="mobile-rcs-badge-text">RCS Enabled</span>
            </span>
          )}
        </div>
        <div className="chat-sidebar-content">
          <SearchBar
            search={search}
            handleOnChange={handleSearch}
            handleOnClear={handleSearchClear}
            showClear={() => checkClear(activeTab)}
            showPatientReport={showPatientReport}
            showPatientLookup={showPatientLookup}
            notConfigured={notConfigured}
            handleDownloadReport={handleDownloadReport}
          />
          {activeTab === "1" && (
            <div className="button-sideNav">
              <span className="sideNavMail">
                <Button onClick={handleUnread} className="sideNav-all-btn">
                  <span className="mailIcon">{sideNavMail}</span> All
                </Button>
              </span>
              <Dropdown
                getPopupContainer={(node) => node.parentNode}
                overlayClassName="label-items"
                className={selectedTagId ? "active-label" : "dropdown-select"}
                menu={{
                  items: sidenavState.labelItems,
                  onClick: (e) => LabelButton(e),
                }}
                icon
              >
                <Button
                  className="sideNav-label-button"
                  onClick={(e) => e.preventDefault()}
                >
                  <span className="SideNavFilter">{SideNavFilter}</span>
                  Labels
                  <span className="SidenavDropdown">{SidenavDropdown}</span>
                </Button>
              </Dropdown>
            </div>
          )}
          <div
            className={`tab-content-pane my-active-tab ${
              activeTab === "1" ? "active" : ""
            }`}
          >
            {isFetchingActivePatientList && (
              <LoadingSpinner
                type="small"
                relative
                customClassName="without-background"
              />
            )}

            <div className="phone-numbers-container" ref={numbersRef}>
              <InfiniteScroll
                pageStart={0}
                loadMore={loadMoreActiveUsers}
                hasMore={hasMore}
                loader={
                  isLoadingActive && (
                    <LoadingSpinner
                      type="small"
                      relative
                      customClassName="without-background-transparent"
                    />
                  )
                }
                threshold={60}
                initialLoad={false}
                useWindow={false}
              >
                {listingActivePatients()}
              </InfiniteScroll>
            </div>
          </div>

          <div
            className={`tab-content-pane unclaimed-tab ${
              activeTab === "2" ? "active" : ""
            }`}
          >
            {isFetchingUnclaimedPatientList && (
              <LoadingSpinner
                type="small"
                relative
                customClassName="without-background"
              />
            )}
            <div className="phone-numbers-container" ref={unclaimedTabRef}>
              <InfiniteScroll
                pageStart={0}
                loadMore={loadMoreUnClaimedUsers}
                hasMore={hasMoreUnclaimed}
                loader={
                  isLoadingActive && (
                    <LoadingSpinner
                      type="small"
                      relative
                      customClassName="without-background-transparent"
                    />
                  )
                }
                threshold={60}
                initialLoad={false}
                useWindow={false}
              >
                {listingUnclaimedPatients()}
              </InfiniteScroll>
            </div>
          </div>

          <div
            className={`tab-content-pane other-staff-tab ${
              activeTab === "4" ? "active" : ""
            }`}
          >
            {isFetchingOtherPatientList && (
              <LoadingSpinner
                type="small"
                relative
                customClassName="without-background"
              />
            )}
            <div className="phone-numbers-container" ref={otherTabRef}>
              <OtherTab
                otherStaffReload={otherStaffReload}
                updateOtherPatientList={updateOthersPatientListSagaAction}
                otherPatients={otherPatients.otherPatientList}
                selectedPatentId={seletedPatientId}
                otherUserClaim={otherUserClaim}
                showAddNew={showAddNew}
                addNewButton={addNewButton}
                search={search}
                otherStaffList={otherStaffList}
                activeTab={activeTab}
              />
            </div>

            {otherPatients?.otherPatientList?.rows?.length <
              otherPatients.otherPatientList?.count && (
              <CustomButton
                htmlType="submit"
                btntype="clear"
                title="Load More"
                onClick={loadMoreOtherUsersNew}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidenavInner;
